import React from 'react';
import { useCallback } from 'react';

export const useSelectActions = <Option>(
  selectRef: React.MutableRefObject<any>,
) => {
  const openMenu = useCallback(() => {
    if (selectRef.current) {
      selectRef.current.onMenuOpen();
    }
  }, [selectRef]);

  const closeMenu = useCallback(() => {
    if (selectRef.current) {
      selectRef.current.blur();
    }
  }, [selectRef]);

  const setFocusedOption = useCallback(
    (focusedOption: Option) => {
      if (selectRef.current && focusedOption) {
        selectRef.current.setState({
          focusedOption,
          focusedValue: null,
        });
      }
    },
    [selectRef],
  );

  return { openMenu, closeMenu, setFocusedOption };
};
